import React from 'react';
import PropTypes from 'prop-types';

import './LockedContent.css';

const LockedContent = ({ children, text }) => {
  return (
    <div aria-disabled={true} className="locked-content__component">
      <div className="locked-content-header">
        <div className="locked-content-header-image" />
        {text &&
          <div className="locked-content-header-text">
            {text}
          </div>
        }
      </div>
      <div className="locked-content-wrapper">
        {children}
      </div>
    </div>
  );
};

LockedContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  text: PropTypes.oneOfType(PropTypes.string, PropTypes.object),
};
LockedContent.defaulProps = {
  text: null,
};


export default LockedContent;
